import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Moment from "react-moment";
import Table from "../Table/Table";
import { requestHandler } from "../../services/requestHandler";
import { roundNumber } from "../../util/fn";

const OBJ_TABLE = {
  Product: "item",
  vendor: "vendor",
  Price: `price`,
  "Admin Earning": `adminCommissionAmt`,
  status: "status",
  "Return Reason": "returnReason",
  "Created On": "createdAt",

  //   status: "isActive",
};

export default function InvoiceOrder({ tabIndex, orderId }) {
  const dispatch = useDispatch();
  const { date_time_format } = useSelector((state) => state.setting);
  // orderOffer
  const [invoiceData, setInvoiceData] = useState([]);
  const [orderOffers, setOrderOffer] = useState({ status: "", data: [] });
  const getInvoice = async () => {
    const response = await requestHandler(
      "GET",
      `orders/get-invoice/${orderId}`,
      {},
      dispatch
    );
    if (response.status && response.data) {
      //   setInvoiceData(response.data);
      const {
        orderConfirmDate,
        product,
        requestId,
        serviceFee,
        shippingFee,
        status,
        totalPrice,
        transaction,
        userData: { name: customer, contact, countryCode },
        vin,
        sparePartsLength,
        orderOffer,
      } = response?.data;
      setOrderOffer({ status, data: orderOffer });
      setInvoiceData([
        { title: "Order Number", value: requestId },

        {
          title: "Customer Info",
          value: `${customer}` + " , " + `+ ${countryCode} ${contact}`,
        },

        {
          title: "Vin",
          value: vin,
        },
        {
          title: "Total Items",

          value: sparePartsLength,
        },
        {
          title: "Order Status",
          value: status,
        },
        {
          title: "Payment Status",
          value: transaction && transaction.status ? transaction.status : "-",
        },

        {
          title: "Products",
          value: product ? product.join(",") : "-",
        },
        {
          title: "Service Fee",
          value: serviceFee ? `$${serviceFee}` : "$0",
        },
        {
          title: "Shipping Fee",
          value: shippingFee ? `$${shippingFee}` : "$0",
        },
        {
          title: "Total Order Amount",
          value: transaction?.amount
            ? `$${transaction?.amount}`
            : totalPrice
            ? `$${totalPrice}`
            : "$0",
        },
        {
          title: "Refunded Amount",
          value: transaction?.refundedAmount
            ? `$${transaction?.refundedAmount}`
            : "$0",
        },
        {
          title: "Refund Reason",
          value: transaction?.refundReason ? transaction?.refundReason : "-",
        },
        {
          title: "Payment Date",
          value: <Moment format={date_time_format}>{orderConfirmDate}</Moment>,
        },
      ]);
    }
  };
  console.log("date_time_format :", date_time_format);
  useEffect(() => {
    getInvoice();
  }, []);
  return (
    <div
      style={{
        display: "block",
      }}
      className="card-body px-0"
    >
      <div className="tab-content px-10">
        <div
          className="tab-pane active"
          id={`kt_apps_contacts_view_tab_0`}
          role="tabpanel"
        >
          {invoiceData.length > 0 &&
            invoiceData.map((item, index) => (
              <div key={index} className="form-group row my-2">
                <label className="col-4 col-form-label">{item.title}</label>
                <div className="col-8">
                  <span className="form-control-plaintext font-weight-bolder">
                    {/* {item.value} */}
                    <span
                      className={`label label-lg label-light-${
                        item.value === "Order Confirmed" ||
                        item.value === "Request Submitted" ||
                        item.value === "Order Delivered" ||
                        item.value === "Success"
                          ? "success"
                          : item.value === "Offer Received" ||
                            item.value === "Refund" ||
                            item.value === "Pending"
                          ? "warning"
                          : item.value === "Order Returned" ||
                            item.value === "Order Cancelled" ||
                            item.value === "Order Partially Returned" ||
                            item.value === "Failed"
                          ? "danger"
                          : "white text-dark"
                      } label-inline`}
                    >
                      {item.value}
                    </span>
                  </span>
                </div>
              </div>
            ))}

          <div className="row"></div>
          <div className="dataTables_wrapper ">
            <Table
              mainData={orderOffers?.data ?? []}
              tableHeading={Object.keys(OBJ_TABLE)}
              tableData={Object.values(OBJ_TABLE)}
              dontShowSort={[
                "Product",
                "vendor",
                "Price",
                "Admin Earning",
                "status",
                "Return Reason",
                "Created On",
              ]}
              renderAs={{
                vendor: (val, id, data) =>
                  val ? (
                    <div>
                      {/* {id ? id.customer  + "," + id.contact : "-"} */}
                      <span>{val.name}</span>
                      <br /> <span>{val.email}</span>
                      <br /> <span>{val.contact ? "+" + val.contact : ""}</span>
                    </div>
                  ) : (
                    ""
                  ),
                adminCommissionAmt: (val, id, data) =>
                  val ? `$${roundNumber(val)}` : "$0",
                returnReason: (val, id, data) => (val ? val : "-"),
                status: (val, id, data) =>
                  data ? (
                    <span
                      style={{ height: "40px" }}
                      className={`label label-lg label-light-${
                        orderOffers.status === "Order Confirmed" ||
                        orderOffers.status === "Order Delivered"
                          ? "success"
                          : orderOffers.status === "Order Returned"
                          ? "danger"
                          : orderOffers.status === "Order Partially Returned" &&
                            data.isReturnedOrder
                          ? "danger"
                          : orderOffers.status === "Order Partially Returned" &&
                            !data.isReturnedOrder
                          ? "success"
                          : ""
                      } label-inline`}
                    >
                      {orderOffers.status === "Order Confirmed" &&
                      !data.isReturnedOrder
                        ? "Ongoing"
                        : orderOffers.status === "Order Delivered" &&
                          !data.isReturnedOrder
                        ? "Delivered"
                        : orderOffers.status === "Order Partially Returned" &&
                          !data.isReturnedOrder
                        ? "Ongoing"
                        : "Returned"}
                    </span>
                  ) : (
                    ""
                  ),
              }}
              onlyDate={{
                createdAt: "dateTime",
                startDate: "dateTime",
                endDate: "dateTime",
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
